import { yupResolver } from '@hookform/resolvers/yup';

import { object, REQUIRED_MESSAGE, email } from './general';

const schema = object().shape({
  email: email().required(REQUIRED_MESSAGE),
});

export default yupResolver(schema);
